module.exports = __webpack_public_path__ + "img/pass_card.7a1343f9.png";